import React from 'react'

import ButtonGroup from '../../Button/ButtonGroup/ButtonGroup'
import Button from '../../Button/Button'

const RowSelectAction = ({ selectedData, name, bulkActionList }: any) => {
    const hanldeClick = (action) => {
        const type = typeof action.label === 'string' ? action.label.toLowerCase() : ''
        action.cb({ data: selectedData, type })
    }
    let showSelectCtaDom: any
    let hasShowSelectCta: boolean
    // eslint-disable-next-line react-hooks/exhaustive-deps
    bulkActionList.map((action: any, i: number) => {
        if (action.showSelected) {
            hasShowSelectCta = true
            showSelectCtaDom = (
                <ButtonGroup>
                    <Button
                        id={`bulk-panel-action-item-0`}
                        aria-label={action.ariaLabel}
                        key={i}
                        buttonType={action.type ? action.type : 'primary'}
                        icon={action.icon ? action.icon : undefined}
                        onClick={() => hanldeClick(action)}
                        testId={action.testId}
                        className={action.label === 'Unpublish' ? 'Button--unpublish' : ''}>
                        {action.label}
                    </Button>
                </ButtonGroup>
            )
        }
    })

    return (
        <div className="TableActionPanel flex-justify flex-v-center">
            <div className="selected-items">
                {hasShowSelectCta ? (
                    showSelectCtaDom
                ) : (
                    <span>
                        {selectedData.length === 1
                            ? `${selectedData.length} ${name.singular} selected `
                            : `${selectedData.length} ${name.plural} selected `}
                    </span>
                )}
            </div>
            <div>
                <ButtonGroup>
                    {
                        // eslint-disable-next-line react-hooks/exhaustive-deps
                        bulkActionList.map((action: any, i: number) => {
                            if (!action.showSelected) {
                                return (
                                    <Button
                                        id={`bulk-panel-action-item-${hasShowSelectCta ? i + 1 : i}`}
                                        aria-label={action.ariaLabel}
                                        key={i}
                                        buttonType={action.type ? action.type : 'primary'}
                                        icon={action.icon ? action.icon : undefined}
                                        onClick={() => hanldeClick(action)}
                                        className={action.label === 'Unpublish' ? 'Button--unpublish' : ''}>
                                        {action.label}
                                    </Button>
                                )
                            }
                        })
                    }
                </ButtonGroup>
            </div>
        </div>
    )
}

export default RowSelectAction

